<template>
  <RadioGroup
    v-bind="$attrs"
  >
    <RadioGroupItem
      :value="value"
      :disabled="disabled"
    />
  </RadioGroup>
</template>

<script setup>
import RadioGroup from './RadioGroup.vue'
import RadioGroupItem from './RadioGroupItem.vue'

defineOptions({
  inheritAttrs: false,
})

defineProps({
  value: {
    type: [String, Boolean, Number],
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})
</script>
